<template>
  <div id="app">
    <navbar-main v-if="homePath === '/'"></navbar-main>
    <router-view :key="$route.name + ($route.params.id || '')"/>
    <Footer v-if="!['Preview', 'Builder'].includes($route.name)" />
  </div>
</template>

<script>
import Navigation from './components/Navigation.vue';
import Footer from './components/Footer.vue';

export default {
  data() {
    return {
      homePath: '/'
    }
  },
  created: function () {
    this.homePath = window.location.pathname
  },
  watch: {
    '$route' (to, from) {
        if(to !== from ) {
          this.homePath = window.location.pathname
        }
        window.scrollTo(0,0)
      }
  },
  components: {
    navbarMain: Navigation,
    Footer
  }
}
</script>

<style>
#app {
  font-family: futura-pt, "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1A1A1A;
}
h1, h2, h3, h4, h5, h6 {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}
a {
  text-decoration: none !important;
}

#nav a, #build-nav a {
  color: #1A1A1A !important;
  display: flex;
}

#nav a .v-btn, #build-nav a .v-btn {
  align-self: inherit;
}

#nav a.router-link-exact-active {
  color: #006AFF;
}

</style>
